var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-container"},[_c(_vm.shortcutOrExpandable,{tag:"component",attrs:{"module":_vm.module,"event-bus":_vm.eventBus}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }